import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the ChatProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChatProvider {

  private api: string;
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
  }


   // Inserta un congreso nuevo
   public insert(congreso,mensajeschat): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    mensajeschat.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "mensajeschat",
      "parametros": mensajeschat,
      "clavecongreso":congreso.clave,
      "origen":mensajeschat.claveasistente,
      "destino":mensajeschat.claveasistentedestino,
      "mensaje":mensajeschat.texto
    };
    console.log(parametros);
    return this.http.post(this.api+"chat/insert.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json(); 
      }
    ).catch(this.handleError);
  }
  // Inserta un congreso nuevo
  public insertreunion(congreso,mensajeschat): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    mensajeschat.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "mensajeschat",
      "parametros": mensajeschat,
      "clavecongreso":congreso.clave,
      "origen":mensajeschat.claveasistente,
      "reunion":mensajeschat.clavereunion,
      "mensaje":mensajeschat.texto
    };
    console.log(parametros);
    return this.http.post(this.api+"chat/insert_reunion.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Devuelve todas las preguntas.
  public listachatindividual(pagina,clavecongreso,asistente_origen,asistente_destino): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "dispositivo": this.global.guid,
      "clavecongreso": clavecongreso,
      "claveasistentedestino": asistente_destino.clave,
      "claveasistenteorigen": asistente_origen.clave,
      "pagina":pagina
    };
   console.log(parametros);
    return this.http.post(this.api + "chat/lista_individual.php", parametros, options).map(
      (response) => {
      
        console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }
  public listachatreunion(pagina,clavecongreso,reunion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "dispositivo": this.global.guid,
      "clavecongreso": clavecongreso,
      "clavereunion": reunion,
      "pagina":pagina
    };
    console.log(parametros);
   
    return this.http.post(this.api + "chat/lista_reunion.php", parametros, options).map(
      (response) => {
      
      console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }
  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/chat/chat.ts